import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = {
  key: 1,
  class: "w-full"
}
const _hoisted_4 = { class: "contactInputGrid mtop-15" }
const _hoisted_5 = { style: {"grid-column":"left","justify-self":"end","margin-top":"0.4rem"} }
const _hoisted_6 = { class: "main-m" }
const _hoisted_7 = { style: {"grid-column":"right"} }
const _hoisted_8 = { style: {"grid-column":"left","justify-self":"end","margin-top":"0.4rem"} }
const _hoisted_9 = { class: "main-m" }
const _hoisted_10 = { style: {"grid-column":"right"} }

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue';
import { useAppUserStore } from '@/stores/appUser';
import { ApiError } from '@/apiGenerate/medserver';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import {  InstituteApi } from "@/apiGenerate/medserver";
import {medServerApiConfig} from "@/config/medserver-api.config";

export default /*@__PURE__*/_defineComponent({
  __name: 'headerInput',
  props: {
    iwr: {},
    header: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const instituteApi = new InstituteApi(medServerApiConfig);

const { t } = useI18n();
const toast = useToast();
const appUserStore = useAppUserStore();

const props = __props;

const emits = __emit;

const customLine1Input = ref(props.header?.customLine1 || '');
const customLine2Input = ref(props.header?.customLine2 || '');

async function updateHeader() {
  if (!props.header) return;
  if (props.header.customLine1 === customLine1Input.value &&
      props.header.customLine2 === customLine2Input.value) return;
  try {
    await instituteApi.updateIwrHeader({
      instituteId: props.iwr.instituteWithRoleId,
      headerId: props.header.instituteHeaderId,
      updateInstituteHeaderRequest: {
        customLine1: customLine1Input.value,
        customLine2: customLine2Input.value,
      }
    });
    toastSuccess(toast, {
      summary: t('common.toast.success.update'),
      detail: t('settings.params.account.toast.update.header'),
    });
    await appUserStore.updateCurrentHealthGroupMembership();
  } catch (error: ApiError) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT'),
    });
  }
}

async function addHeader() {
  emits('close');
  try {
    await instituteApi.addHeaderToIwr({
      instituteId: props.iwr.instituteWithRoleId,
      addInstituteHeaderRequest: {
        customLine1: customLine1Input.value,
        customLine2: customLine2Input.value,
      }
    });
    toastSuccess(toast, {
      summary: t('common.toast.success.add'),
      detail: t('settings.params.account.toast.add.header'),
    });
    await appUserStore.updateCurrentHealthGroupMembership();
  } catch (error: ApiError) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT'),
    });
  }
}

async function deleteHeader() {
  emits('close');
  try {
    await instituteApi.deleteIwrHeader({
      instituteId: props.iwr.instituteWithRoleId,
      headerId: props.header.instituteHeaderId,
    });
    toastSuccess(toast, {
      summary: t('common.toast.success.delete'),
      detail: t('settings.params.account.toast.delete.header'),
    });
    await appUserStore.updateCurrentHealthGroupMembership();
  } catch (error: ApiError) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT'),
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('settings.label.account.institute.preference.headerLines'),
          styles: "font-l"
        }, null, 8, ["txt"])
      ]),
      (props.header)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            styles: "rnd-m",
            class: "mleft-08",
            style: {"margin-top":"-0.2rem"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteHeader()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "trash",
                styles: "main-l"
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_buttonGroup, {
              class: "padButton-m",
              styles: "border-h",
              style: {"margin-left":"auto"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (addHeader()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('action.create'),
                  styles: "font-mBold main-h"
                }, null, 8, ["txt"])
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('settings.params.account.prescription.labelCustomLine1')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: customLine1Input.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customLine1Input).value = $event)),
              onBlur: updateHeader
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('settings.params.account.prescription.labelCustomLine2')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: customLine2Input.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customLine2Input).value = $event)),
              onBlur: updateHeader
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mtop-04" }, null, -1))
  ]))
}
}

})